var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 61,
    viewBox: "0 0 67 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_234_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.72 22.0234L37.9282 39.5498L46.9293 48.8319L47.9465 44.5213L56.554 53.8461L22.3932 60.9994L63.8972 60.8611L67 48.4781L42.72 22.0234Z",
    fill: "#1E1C21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2136 39.0766L18.7743 42.3279L21.9524 45.3759L9.67285 48.2601L20.634 14.7305L0 51.1922L9.04125 60.1033L43.8095 52.0421L31.2136 39.0766Z",
    fill: "#5C5762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9761 33.427L38.4152 20.8935L34.219 22.1562L37.8921 9.94707L61.0906 36.3235L40.2207 0L28.0777 3.47192L17.5894 37.9878L34.9761 33.427Z",
    fill: "#35AB33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_234_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 61,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4701c96d59d32bdadd5f5a4fd6d57346.svg";
export { ForwardRef as ReactComponent };